var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.colorRangeData
    ? _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("form", { staticClass: "modal-form" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  ref: "close",
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.cancelDialog()
                    },
                  },
                },
                [_c("span", [_vm._v("×")])]
              ),
              _vm._v(" "),
              _c("h4", [_vm._v(_vm._s(_vm.headerMessage))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.validationErrors.length > 0
                ? _c("div", { staticClass: "errors" }, [
                    _c("p", [_vm._v("Errors")]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(this.validationErrors, function (error) {
                        return _c("li", { key: error }, [_vm._v(_vm._s(error))])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.type === "heatmap"
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "h-griddata-radius" } }, [
                      _vm._v("Radius"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.radius,
                          expression: "radius",
                        },
                      ],
                      staticClass: "input-sm form-control",
                      attrs: {
                        id: "h-griddata-radius",
                        type: "number",
                        min: "1",
                      },
                      domProps: { value: _vm.radius },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.radius = $event.target.value
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "h-griddata-range" } }, [
                  _vm._v("Range Colors"),
                ]),
                _vm._v(" "),
                _c(
                  "table",
                  {
                    staticClass: "table table-bordered table-condensed",
                    attrs: { id: "h-griddata-range" },
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Value")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Color")]),
                        _vm._v(" "),
                        _c("th", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.addNewFirstColor.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "icon-plus",
                                attrs: { title: "Add new first color" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        this.type === "griddata"
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    title:
                                      "The color of values below the lowest range value",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Minimum color\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("color-picker-input", {
                                    attrs: { color: _vm.minColor },
                                    model: {
                                      value: _vm.minColor,
                                      callback: function ($$v) {
                                        _vm.minColor = $$v
                                      },
                                      expression: "minColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.colorRangeData, function (entry, index) {
                          return _c("tr", { key: entry.key }, [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: entry.value,
                                    expression: "entry.value",
                                  },
                                ],
                                staticClass: "input-sm form-control",
                                attrs: { type: "number", step: "0.1" },
                                domProps: { value: entry.value },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      entry,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("color-picker-input", {
                                  attrs: { color: entry.colorString },
                                  model: {
                                    value: entry.colorString,
                                    callback: function ($$v) {
                                      _vm.$set(entry, "colorString", $$v)
                                    },
                                    expression: "entry.colorString",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.addColor(index)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-plus",
                                    attrs: { title: "Add row below" },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.removeColor(index)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-minus",
                                    attrs: { title: "Remove this row" },
                                  }),
                                ]
                              ),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        this.type === "griddata"
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    title:
                                      "The color of values above the highest range value",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Maximum color\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("color-picker-input", {
                                    attrs: { color: _vm.maxColor },
                                    model: {
                                      value: _vm.maxColor,
                                      callback: function ($$v) {
                                        _vm.maxColor = $$v
                                      },
                                      expression: "maxColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.normalizeRange,
                        expression: "normalizeRange",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.normalizeRange)
                        ? _vm._i(_vm.normalizeRange, null) > -1
                        : _vm.normalizeRange,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.normalizeRange,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.normalizeRange = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.normalizeRange = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.normalizeRange = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("b", [_vm._v("Normalize Range")]),
                ]),
              ]),
              _vm._v(" "),
              this.type === "heatmap"
                ? _c("div", { staticClass: "checkbox" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.scaleWithZoom,
                            expression: "scaleWithZoom",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.scaleWithZoom)
                            ? _vm._i(_vm.scaleWithZoom, null) > -1
                            : _vm.scaleWithZoom,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.scaleWithZoom,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.scaleWithZoom = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.scaleWithZoom = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.scaleWithZoom = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b", [_vm._v("Scale With Zoom")]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.interpretation === "contour" ||
              this.interpretation === "chloropleth"
                ? _c("div", { staticClass: "checkbox" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.stepped,
                            expression: "stepped",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.stepped)
                            ? _vm._i(_vm.stepped, null) > -1
                            : _vm.stepped,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.stepped,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.stepped = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.stepped = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.stepped = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b", [_vm._v("Stepped")]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button", id: "close" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.cancelDialog()
                    },
                  },
                },
                [_vm._v("\n                    Cancel\n                ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.submitClicked()
                    },
                  },
                },
                [_vm._v("\n                    Submit\n                ")]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib/loaders/templateLoader.js?{}!/opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib?{}!./~/@girder/histomicsui/vue/components/EditHeatmapOrGridData.vue?vue&type=template&id=0e0c107c&
// module id = 68
// module chunks = 0